export default "__VITE_ASSET__Bz$1oK63__"